import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight } from '@mui/icons-material';
import { Menu } from '../Menu';
import { UserProfile } from '../auth/UserProfile';
import { useAuth } from '@/hooks/useAuth';

interface DrawerContentProps {
  collapsed: boolean;
  onCollapseToggle: () => void;
}

export const DrawerContent: React.FC<DrawerContentProps> = ({ collapsed, onCollapseToggle }) => {
  const { isAuthenticated, user } = useAuth();

  return (
  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
      <Menu collapsed={collapsed} />
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: collapsed ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'space-between',
        gap: collapsed ? 0.5 : 1,
        px: collapsed ? 0.5 : 2,
        py: 1,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.015)',
      }}
    >
      {isAuthenticated && user && (
        <Box sx={{ minWidth: 0, flex: collapsed ? undefined : 1 }}>
          <UserProfile variant="full" collapsed={collapsed} />
        </Box>
      )}
      <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
        <Tooltip title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
          <span>
            <IconButton
              color="default"
              size="small"
              aria-label={collapsed ? 'expand sidebar' : 'collapse sidebar'}
              onClick={onCollapseToggle}
            >
              {collapsed ? <KeyboardDoubleArrowRight /> : <KeyboardDoubleArrowLeft />}
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>
  </Box>
  );
};
